import React, { useState } from "react";
import css from "../../style/forgotPassword.module.css";
import { useHistory, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { ConfirmEmailAction } from "../../store/actions/loginActions";
import { FaKey } from "react-icons/fa";
const ConfirmEmail = () => {
  // verification code
  const [verificationcode, setverificationcode] = useState();
  //history for routing
  const history = useHistory();
  // dispatch actions
  const dispatch = useDispatch();
  // getting error
  const { loginError } = useSelector((state) => state.loginReducer);

  // email and user id from params
  const { email } = useParams();
  // verification cide
  const [verificationcodeActive, setverificationcodeActive] = useState(false);
  // forgot password
  const handleConfirmEMail = () => {
    if (verificationcode) {
      dispatch(ConfirmEmailAction(email, verificationcode, history));
    } else {
      alert("Please fill all the fields");
    }
  };
  return (
    <div className={css?.signup_page}>
      <div className={css?.inner_content}>
        <div class={css?.RegisterMainHeading}>Verify Email</div>
        {/* <div className={css?.dash_with_title}>
            Don't have an account?{" "}
            <span
              className={css?.signupButton}
              onClick={() => history.push("/Registerwemoovez")}
            >
              Sign up
            </span>
          </div> */}

        <div className={css?.dash_with_title}>
          A verification code has been sent to {email}. Please verify your
          email.
        </div>
        <div class={css?.sign_up_form}>
          <div class={css?.fullInputleft}>
            <span className={css?.textIconsFull}>
              <FaKey />
            </span>
            <input
              placeholder="Code"
              className={css?.inputFieldFull}
              value={verificationcode}
              onFocus={() => setverificationcodeActive(true)}
              onChange={(e) => setverificationcode(e?.target?.value)}
            />
            {verificationcodeActive && !verificationcode && (
              <span className={css?.crossIconFull}>
                <FaKey />
              </span>
            )}
          </div>
        </div>
        {/* <div style={{ color: "red" }}>{loginError ? loginError : ""}</div> */}
        <div className={css?.BottomButtons2}>
          <div className={css?.dash_with_title}>
            Back to{" "}
            <span
              className={css?.signupButton}
              onClick={() => history.push("/Driver/signup")}
            >
              Sign up
            </span>
          </div>
          <button onClick={handleConfirmEMail} className={css?.submitButton}>
            Confirm Email
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmEmail;
